import { useState, useEffect, useCallback } from 'react';
import { TradingClosure, tradingClosureService } from '../services/tradingClosureService';

// Closures can change from another tab or from the PnL bot, so the list is re-read periodically.
const REFRESH_INTERVAL_MS = 10000;

interface UseTradingClosuresResult {
  closures: TradingClosure[];
  error: Error | null;
  refreshClosures: () => Promise<void>;
}

export const useTradingClosures = (): UseTradingClosuresResult => {
  const [closures, setClosures] = useState<TradingClosure[]>([]);
  const [error, setError] = useState<Error | null>(null);

  const fetchClosures = useCallback(async () => {
    try {
      setClosures(await tradingClosureService.listClosures());
      setError(null);
    } catch (err) {
      console.error('Error loading trading closures:', err);
      setError(err as Error);
    }
  }, []);

  useEffect(() => {
    fetchClosures();
    const timer = setInterval(fetchClosures, REFRESH_INTERVAL_MS);
    return () => clearInterval(timer);
  }, [fetchClosures]);

  return { closures, error, refreshClosures: fetchClosures };
};
